module.exports = __webpack_public_path__ + "img/shop_name.aa71d87a.png";